import type { Aktivitet } from '@klp/formgenerator/interfaces';

export type Leverandorvurdering = {
    orgnummer?: string;
    superOfficeContactId?: string;
    leverandorId?: string;
    navn?: string;
    klassifiseringKode?: string;
    klassifiseringBeskrivelse?: string;
};

export enum LEVERANDOR_REGISTRERING_STATUS {
    UNDER_VURDERING = 'UnderVurdering',
    FULLFORT = 'Fullfort',
    AVVIST = 'Avvist',
}

export enum LEVERANDOR_REGIONS {
    Oslo = 'Oslo',
    Trondheim = 'Trondheim',
    Sverige = 'Sverige',
    Danmark = 'Danmark',
    Europa = 'Europa',
}

export enum LEVERANDOR_CULTURE_CODES {
    Norwegian = 'nb-NO',
    Swedish = 'sv-SE',
    Danish = 'da-DK',
    English = 'en-US',
}

export enum COUNTRY_WITH_API_SUPPORT {
    Norway = 'Norway',
    Sweden = 'Sweden',
    Denmark = 'Denmark',
    UnitedKingdom = 'United Kingdom',
}

export const COUNTRIES_WITH_API_SUPPORT_LIST: ReadonlyArray<string> = [
    COUNTRY_WITH_API_SUPPORT.Norway,
    COUNTRY_WITH_API_SUPPORT.Sweden,
    COUNTRY_WITH_API_SUPPORT.Denmark,
    COUNTRY_WITH_API_SUPPORT.UnitedKingdom,
];

export type COUNTRY_MENU_OPTION = COUNTRY_WITH_API_SUPPORT | 'Other';

export type LeverandorGodkjenningProsessResponse = {
    orgnummer: string;
    superOfficeContactId: string;
    navn?: string;
    startDato?: string;
    fullfortDato?: string;
    lastUpdated?: string;
    startetAvBruker?: string;
    aktiviteter?: Array<Aktivitet>;
    currentAktivitet?: Aktivitet;
    bestiller?: string;
    avdelingsleder?: string;
    okonomi?: string;
    prosessInstansId: string;
    prosessDefinisjonKey?: string;
    prosessDefinisjonId?: string;
    d365Leverandornummer?: string;
    leverandorvurdering: Leverandorvurdering | null;
    registreringStatus?: string;
    bestillerFulltnavn?: string;
    avdelingslederFulltnavn?: string;
    okonomiFulltnavn?: string;
    opprettetAv?: string;
    superOfficeDocumentId?: string;
    region: LEVERANDOR_REGIONS;
    avvistKommentar?: string;
    type: string;
};

export type LeverandorStatistics = {
    TildeltMeg: number;
    UnderVurdering: number;
    Fullfort: number;
    Avvist: number;
};

// Risikovurdering
export enum RisikoVurderingStatus {
    FunnetICache = 'FunnetICache',
    FunnetIDnB = 'FunnetIDnB',
    IkkeFunnetICacheIkkeRettigheter = 'IkkeFunnetICacheIkkeRettigheter',
    IkkeFunnetIDNB = 'IkkeFunnetIDNB',
    Annet = 'Annet',
}

type Adresse = {
    landsKode?: string;
    sted?: string;
    postNummer?: string;
    postBoks?: string;
    gate?: string;
};

type DatoMnd = {
    dag?: number;
    maaned?: number;
    aar?: number;
};

type HistoriskEndring = {
    datoMnd?: DatoMnd;
    endring?: string;
};

type Hendelse = {
    dato?: string;
    hendelse?: string;
};

type Industrikode = {
    kode?: string;
    beskrivelse?: string;
    type?: string;
};

type HistoriskRating = {
    rapporteringsDato?: DatoMnd;
    ratingKode?: string;
    ratingBeskrivelse?: string;
};

type RevisorInfo = {
    registrert?: DatoMnd;
    rolle?: string;
    navn?: string;
    orgNummer?: string;
};

type RevisorsKommentarerTilRegnskap = {
    kode?: string;
    beskrivelse?: string;
    registrert?: string;
};

export type Foretak = {
    navn?: string;
    organisasjonsnummer?: string;
    contactId: number | null;
    aarsregnskap?: string;
    rating?: string;
    betalingsanmerkning?: string;
    soliditet?: string;
    aktuellHendelse?: string;
    sanksjonert?: boolean;
    dunsnr?: number;
    ratingBeskrivelse?: string;
    mvaRegistrert?: string;
    telefon?: string;
    hjemmeside?: string;
    juridiskAdresse?: Adresse;
    besoksAdresse?: Adresse;
    postAdresse?: Adresse;
    fylkeKommune?: string;
    historiskeNavn?: Array<HistoriskEndring>;
    grunnFakta?: string;
    eierJuridisk?: string;
    oekonomi?: string;
    betalingsevne?: string;
    historiskRating?: Array<HistoriskRating>;
    overordnetVurdering?: string;
    sperretID365?: boolean;
    klassifisering?: string;
    leverandorNummer?: string;
    revisorInfo?: Array<RevisorInfo>;
    revisorsKommentarerTilRegnskap?: Array<RevisorsKommentarerTilRegnskap>;
    evalueringskommentar?: string;
    sistVurdert?: string;
    ratingDato?: string;
    fraCache?: string;
    sanksjonFraCache?: string;
    hendelser?: Array<Hendelse>;
    industriKoder?: Array<Industrikode>;
    manuellSanksjonssjekk: string | null;
    manuellSanksjonssjekkKommentar: string | null;
    erAarsregnskapGodkjentInnenFristen: boolean | null;
};
